import React from "react";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { MoveUpRight, MessageSquare, PhoneOutgoing } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { formatDistanceToNow, parse } from "date-fns";
import { es } from "date-fns/locale";

export default function ContactsList({
  data = [],
  pipelines = [],
  onSelect = () => {},
}) {
  const map = {
    Whatsapp_Button: "WhatsApp",
    Call_Button: "Llamada",
  };

  return (
    <div>
      {data.map((contact) => {
        const parsedDate = parse(
          contact.created,
          "dd-MM-yyyy HH:m:s",
          new Date()
        );
        const formattedDate = formatDistanceToNow(parsedDate, {
          locale: es,
          addSuffix: true,
        });
        return (
          <Card key={contact.id} className="mb-4">
            <CardHeader>
              <CardTitle className="flex justify-between items-center">
                <div className="flex items-center gap-2 w-full">
                  <Avatar>
                    <AvatarFallback>
                      {contact?.name
                        ? contact.name.split(" ")[0]?.[0] +
                          (contact.name.split(" ")[1]?.[0] || "")
                        : "?"}
                    </AvatarFallback>
                  </Avatar>
                  <div className="flex flex-col">
                    <div>{contact.name}</div>
                    <div className="text-sm text-gray-500">{formattedDate}</div>
                  </div>
                  <div className="flex-grow flex"></div>
                  <div>
                    {contact.pipeline_status?.stage?.name && (
                      <Badge
                        style={{
                          backgroundColor: pipelines[0].stages.find(
                            (stage) =>
                              stage.id === contact.pipeline_status?.stage?.id
                          )?.color,
                          opacity: 0.8,
                        }}
                      >
                        {contact.pipeline_status?.stage?.name}
                      </Badge>
                    )}
                    {contact.utm_campaign && (
                      <Badge className="ml-2 bg-green-800">
                        {map[contact.utm_campaign] || contact.utm_campaign}
                      </Badge>
                    )}
                  </div>
                </div>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription>
                <div className="flex flex-col md:flex-row gap-2 my-3">
                  <a
                    href={`https://wa.me/${contact.phone?.replace(/\D/g, "")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button className="w-full">
                      <MessageSquare className="mr-2 h-4 w-4 " />
                      Iniciar conversación en WhatsApp
                    </Button>
                  </a>

                  <a
                    href={`tel:${contact.phone?.replace(/\D/g, "")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button variant="outline" className="w-full">
                      <PhoneOutgoing className="mr-2 h-4 w-4 " />
                      Llamar
                    </Button>
                  </a>

                  <Button
                    variant="outline"
                    className="w-full"
                    onClick={() => onSelect(contact)}
                  >
                    Ver Detalles
                  </Button>
                </div>
              </CardDescription>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
